(function () {
  const root = document.querySelector("[data-appointments-booking]");
  if (!root) return;

  const loadingEl = root.querySelector("[data-booking-loading]");
  const errorEl = root.querySelector("[data-booking-error]");
  const appEls = Array.from(root.querySelectorAll("[data-booking-app]"));
  const stepPanelEls = Array.from(root.querySelectorAll("[data-booking-step-panel]"));
  const stepTabEls = Array.from(root.querySelectorAll("[data-booking-step-tab]"));
  const stepBackEl = root.querySelector("[data-booking-step-back]");
  const dateSelectEl = root.querySelector("[data-booking-date]");
  const metaEl = root.querySelector("[data-booking-meta]");
  const slotsEl = root.querySelector("[data-booking-slots]");
  const citySwitchSlotEl = root.querySelector("[data-booking-city-switch-slot]");
  const citySwitchEl = root.querySelector("[data-booking-city-switch]");
  const cityTabEls = Array.from(root.querySelectorAll("[data-booking-city-tab]"));
  const availabilityBodyEl = root.querySelector("[data-booking-availability-body]");
  const cityNoticeEl = root.querySelector("[data-booking-city-notice]");
  const preferenceToggleEl = root.querySelector("[data-booking-preference-toggle]");
  const preferenceModalEl = root.querySelector("[data-booking-preference-modal]");
  const preferenceCloseEls = Array.from(root.querySelectorAll("[data-booking-preference-close]"));
  const preferenceFormEl = root.querySelector("[data-booking-preference-form]");
  const preferenceDateEl = root.querySelector("[data-booking-preference-date]");
  const preferenceTimeEl = root.querySelector("[data-booking-preference-time]");
  const preferenceDateOptionsEl = root.querySelector("[data-booking-preference-date-options]");
  const preferenceTimeOptionsEl = root.querySelector("[data-booking-preference-time-options]");
  const preferenceNotesEl = root.querySelector("[data-booking-preference-notes]");
  const formEl = root.querySelector("[data-booking-form]");
  const selectedEl = root.querySelector("[data-booking-selected]");
  const selectedNoteEl = root.querySelector("[data-booking-selected-note]");
  const submitEl = root.querySelector("[data-booking-submit]");
  const inlineErrorEl = root.querySelector("[data-booking-inline-error]");
  const confirmationEl = root.querySelector("[data-booking-confirmation]");
  const confirmationTitleEl = root.querySelector("[data-booking-confirmation-title]");
  const confirmationRecapEl = root.querySelector("[data-booking-confirmation-recap]");
  const translationsEl = document.querySelector("[data-booking-translations]");
  const videoCardEls = Array.from(root.querySelectorAll("[data-booking-video-card]"));
  const slotStepPanelEl = root.querySelector("[data-booking-step-panel=\"slot\"]");
  const locationUrl = String(root.getAttribute("data-booking-location-url") || "").trim();
  const showroomDetailEls = Array.from(root.querySelectorAll("[data-showroom-detail]"));

  let translations = {};
  let config = null;
  let selectedSlot = null;
  let currentCity = "casablanca";
  let currentStep = "slot";
  let appVisible = false;
  let preferenceVisible = false;
  let citySwitchStickyRaf = 0;
  const preferenceTimeOptions = ["10:00", "11:00", "12:00", "15:00", "16:00", "17:00", "18:00", "19:00"];
  try {
    translations = translationsEl ? (JSON.parse(translationsEl.textContent || "{}") || {}) : {};
  } catch (_error) {
    translations = {};
  }
  const locale = String(translations.locale || root.getAttribute("data-booking-locale") || document.documentElement.lang || "en").trim() || "en";
  const typeLabels = translations.typeLabels || {};

  function trackBookingEvent(type, metadata) {
    try {
      document.dispatchEvent(new CustomEvent("bfl:behavior", {
        detail: {
          type: type,
          pageType: "appointment",
          metadata: Object.assign({ action: type }, metadata || {})
        }
      }));
    } catch (_error) {}
  }

  function appointmentLeadRefPrefix() {
    const text = String(window.location.pathname || "").toLowerCase();
    return text.indexOf("fw-2026") >= 0 || text.indexOf("fw2026") >= 0 ? "BFL-FW26-" : "BFL-WA-";
  }

  function buildAppointmentLeadRef() {
    const bytes = new Uint8Array(4);
    let suffix = "";
    if (window.crypto && typeof window.crypto.getRandomValues === "function") {
      window.crypto.getRandomValues(bytes);
      suffix = Array.from(bytes).map((value) => {
        return value.toString(36).toUpperCase().padStart(2, "0");
      }).join("").replace(/[^A-Z0-9]/g, "").slice(0, 8);
    }
    if (!suffix) suffix = String(Date.now()).slice(-6) + String(Math.random()).slice(2, 4);
    return appointmentLeadRefPrefix() + suffix;
  }

  function t(key, fallback) {
    const value = translations && translations[key];
    return typeof value === "string" && value.trim() ? value : fallback;
  }

  function localizeErrorMessage(message, fallback) {
    const code = String(message || "").trim();
    switch (code) {
      case "storefront_booking_disabled":
        return t("errorDisabled", fallback || "Online appointments are not available at the moment.");
      case "slot_unavailable":
      case "slot_conflict":
        return t("errorExpired", fallback || "This time is no longer available. Please choose another one.");
      case "invalid_booking_payload":
        return t("errorChoose", fallback || "Please review your request details.");
      case "rate_limited":
        return t("errorRateLimited", "Please wait a moment before trying again.");
      case "invalid_date":
      case "request_failed":
        return fallback || t("errorLoading", "Unable to load appointments.");
      default:
        return code || fallback || t("errorLoading", "Unable to load appointments.");
    }
  }

  function slotIsStillBookable(slot) {
    if (!slot || !slot.appointmentAt) return false;
    const appointmentMs = new Date(String(slot.appointmentAt)).getTime();
    return Number.isFinite(appointmentMs) && appointmentMs > Date.now();
  }

  function setLoading(visible) {
    if (loadingEl) loadingEl.hidden = !visible;
  }

  function renderSlotsState(message, extraClass) {
    if (!slotsEl) return;
    const className = "appointments-booking-state appointments-booking-state--slots" + (extraClass ? " " + extraClass : "");
    slotsEl.innerHTML = "<div class=\"" + className + "\">" + message + "</div>";
  }

  function showError(message) {
    if (!errorEl) return;
    errorEl.hidden = !message;
    errorEl.textContent = message || "";
  }

  function showInlineError(message) {
    if (!inlineErrorEl) return;
    inlineErrorEl.hidden = !message;
    inlineErrorEl.textContent = message || "";
  }

  // La confirmation s'affiche dans l'étape 2, à la place du formulaire: la cliente
  // la voit là où elle vient de cliquer, pas en haut de page hors écran.
  function setBookingSent(sent, slot) {
    const isSent = Boolean(sent);
    if (formEl) formEl.classList.toggle("is-sent", isSent);
    if (confirmationEl) confirmationEl.hidden = !isSent;
    if (!isSent) return;
    if (confirmationTitleEl) {
      confirmationTitleEl.textContent = t("success", "Your request has been received and is pending confirmation.");
    }
    if (confirmationRecapEl) {
      confirmationRecapEl.textContent = slot ? formatSlotSummary(slot) : "";
    }
    if (confirmationEl && typeof confirmationEl.scrollIntoView === "function") {
      confirmationEl.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  function setPreferenceVisible(visible) {
    preferenceVisible = Boolean(visible);
    if (preferenceModalEl) preferenceModalEl.hidden = !preferenceVisible;
    if (preferenceToggleEl) preferenceToggleEl.classList.toggle("is-active", preferenceVisible);
    document.body.classList.toggle("appointments-booking-modal-open", preferenceVisible);
    if (preferenceVisible) {
      window.setTimeout(() => {
        const dialog = root.querySelector("[data-booking-preference-dialog]");
        if (dialog && typeof dialog.focus === "function") dialog.focus();
      }, 40);
    } else if (preferenceToggleEl) {
      preferenceToggleEl.focus();
    }
  }

  function setAppVisible(visible) {
    appVisible = visible;
    appEls.forEach((element) => {
      element.hidden = !visible;
    });
    if (visible) {
      setStep(currentStep);
    }
    scheduleCitySwitchStickyUpdate();
  }

  function setCity(city) {
    currentCity = city === "rabat" ? "rabat" : "casablanca";
    root.setAttribute("data-booking-city", currentCity);
    cityTabEls.forEach((tab) => {
      const isActive = (tab.getAttribute("data-booking-city-tab") || "") === currentCity;
      tab.classList.toggle("is-active", isActive);
      tab.setAttribute("aria-pressed", String(isActive));
    });
    const isRabat = currentCity === "rabat";
    if (availabilityBodyEl) availabilityBodyEl.hidden = isRabat;
    if (cityNoticeEl) cityNoticeEl.hidden = !isRabat;
    if (isRabat) {
      setPreferenceVisible(false);
    }
    scheduleCitySwitchStickyUpdate();
  }

  function setStep(step, options) {
    const settings = options || {};
    const previousStep = currentStep;
    const nextStep = step === "details" && selectedSlot ? "details" : "slot";
    currentStep = nextStep;
    root.setAttribute("data-booking-step", currentStep);
    if (currentStep === "slot") setBookingSent(false);

    stepPanelEls.forEach((panel) => {
      panel.hidden = !appVisible || panel.getAttribute("data-booking-step-panel") !== currentStep;
    });

    stepTabEls.forEach((tab) => {
      const tabStep = tab.getAttribute("data-booking-step-tab") || "slot";
      const isDetails = tabStep === "details";
      const enabled = !isDetails || Boolean(selectedSlot);
      tab.disabled = !enabled;
      tab.classList.toggle("is-active", tabStep === currentStep);
      tab.setAttribute("aria-selected", String(tabStep === currentStep));
    });

    if (settings.scroll) {
      const panel = stepPanelEls.find((element) => element.getAttribute("data-booking-step-panel") === currentStep);
      if (panel) {
        panel.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
    scheduleCitySwitchStickyUpdate();
    if (appVisible && previousStep !== currentStep) {
      trackBookingEvent("appointment_intent", { action: "step_changed", step: currentStep, city: currentCity });
    }
  }

  function initVideoCard(videoCardEl) {
    if (!videoCardEl) return;
    const videoEl = videoCardEl.querySelector("[data-booking-video]");
    if (!videoEl) return;
    const videoOverlayEl = videoCardEl.querySelector(".appointments-booking-video-overlay");
    const videoTriggerEl = videoCardEl.querySelector("[data-booking-video-trigger]");
    const source = String(videoEl.getAttribute("data-src") || "").trim();
    if (!source) return;
    const mobileImmediate = String(videoEl.getAttribute("data-mobile-immediate") || "").trim().toLowerCase();
    const loadMode = String(videoEl.getAttribute("data-load-mode") || "").trim().toLowerCase();
    const requiresInteraction = loadMode === "interaction";
    const prefersImmediateLoad = mobileImmediate !== "false" && window.matchMedia && window.matchMedia("(max-width: 720px)").matches;

    let loaded = false;
    let fadeTimeoutId = 0;
    let loopGuardLastTime = 0;
    let playRetryCount = 0;

    const tryPlayVideo = () => {
      const playAttempt = videoEl.play();
      if (playAttempt && typeof playAttempt.catch === "function") {
        playAttempt.catch(() => {});
      }
    };

    const clearFadeTimeout = () => {
      if (fadeTimeoutId) {
        window.clearTimeout(fadeTimeoutId);
        fadeTimeoutId = 0;
      }
    };

    const resetOverlay = () => {
      if (videoOverlayEl) {
        videoOverlayEl.classList.remove("is-fading-out");
      }
    };

    const scheduleOverlayFade = () => {
      clearFadeTimeout();
      resetOverlay();
      const duration = Number(videoEl.duration || 0);
      const currentTime = Number(videoEl.currentTime || 0);
      if (!videoOverlayEl || !Number.isFinite(duration) || duration <= 5 || !Number.isFinite(currentTime)) return;
      const delayMs = Math.max(0, (duration - currentTime - 5) * 1000);
      fadeTimeoutId = window.setTimeout(() => {
        if (videoOverlayEl) {
          videoOverlayEl.classList.add("is-fading-out");
        }
      }, delayMs);
    };

    const loadVideo = () => {
      if (loaded) return;
      loaded = true;
      if (videoCardEl) {
        videoCardEl.classList.add("is-video-loading");
      }
      videoEl.src = source;
      if (prefersImmediateLoad) {
        videoEl.preload = "metadata";
      }
      videoEl.load();
      tryPlayVideo();
    };

    videoEl.addEventListener("loadeddata", () => {
      videoEl.classList.add("is-ready");
      if (videoCardEl) {
        videoCardEl.classList.add("is-video-ready");
        videoCardEl.classList.remove("is-video-loading");
      }
      scheduleOverlayFade();
    }, { once: true });

    videoEl.addEventListener("loadedmetadata", tryPlayVideo);
    videoEl.addEventListener("play", scheduleOverlayFade);
    videoEl.addEventListener("pause", clearFadeTimeout);
    videoEl.addEventListener("seeking", () => {
      resetOverlay();
      clearFadeTimeout();
    });
    videoEl.addEventListener("seeked", scheduleOverlayFade);
    videoEl.addEventListener("ended", () => {
      loopGuardLastTime = 0;
      resetOverlay();
      scheduleOverlayFade();
    });
    videoEl.addEventListener("timeupdate", () => {
      const currentTime = Number(videoEl.currentTime || 0);
      if (currentTime < loopGuardLastTime - 1) {
        resetOverlay();
        scheduleOverlayFade();
      }
      loopGuardLastTime = currentTime;
    });
    document.addEventListener("visibilitychange", () => {
      if (!document.hidden && loaded && videoEl.paused) {
        tryPlayVideo();
      }
    });

    const nudgePlay = () => {
      if (!loaded) return;
      if (videoEl.paused && playRetryCount < 4) {
        playRetryCount += 1;
        tryPlayVideo();
      }
    };
    window.addEventListener("pageshow", nudgePlay, { passive: true });
    if (!requiresInteraction && prefersImmediateLoad) {
      window.addEventListener("touchstart", nudgePlay, { passive: true, once: true });
    }

    if (requiresInteraction) {
      if (videoTriggerEl) {
        videoTriggerEl.addEventListener("click", loadVideo);
      }
    } else if (prefersImmediateLoad) {
      loadVideo();
    } else if ("IntersectionObserver" in window && videoCardEl) {
      const observer = new IntersectionObserver((entries) => {
        const isVisible = entries.some((entry) => entry.isIntersecting);
        if (isVisible) {
          observer.disconnect();
          loadVideo();
        }
      }, { rootMargin: "220px 0px" });
      observer.observe(videoCardEl);
    } else {
      loadVideo();
    }
  }

  function initVideo() {
    videoCardEls.forEach(initVideoCard);
  }

  function getDocumentTop(element) {
    let top = 0;
    let node = element;
    while (node) {
      top += Number(node.offsetTop || 0);
      node = node.offsetParent;
    }
    return top;
  }

  function getMobileStickyTop() {
    const margin = 12;
    const selectors = [
      "header",
      "sticky-header",
      ".site-header",
      ".pageheader",
      ".header-wrapper",
      ".section-header",
      ".shopify-section-header",
      "[id^=\"shopify-section\"][id*=\"header\"]",
      ".announcement-bar"
    ];
    let headerBottom = 0;
    const seen = new Set();
    document.querySelectorAll(selectors.join(",")).forEach((element) => {
      if (!element || seen.has(element) || root.contains(element)) return;
      seen.add(element);
      const rect = element.getBoundingClientRect();
      const style = window.getComputedStyle(element);
      if (style.display === "none" || style.visibility === "hidden") return;
      if (rect.width < window.innerWidth * 0.5 || rect.height <= 0) return;
      if (rect.bottom <= 0 || rect.top > margin + 1) return;
      if (rect.bottom > window.innerHeight * 0.45) return;
      headerBottom = Math.max(headerBottom, rect.bottom);
    });
    return Math.max(margin, Math.round(headerBottom + margin));
  }

  function syncMobileStickyTop() {
    const isMobile = window.matchMedia && window.matchMedia("(max-width: 720px)").matches;
    if (!isMobile) {
      root.style.removeProperty("--appointments-mobile-sticky-top");
      return 12;
    }
    const stickyTop = getMobileStickyTop();
    root.style.setProperty("--appointments-mobile-sticky-top", `${stickyTop}px`);
    return stickyTop;
  }

  /* Hauteur de la carte vidéo collante (mobile): elle occupe le haut de l'écran
     sous le header, donc elle doit être retirée de la zone de lecture visée. */
  function getStickyVideoHeight() {
    let height = 0;
    videoCardEls.forEach((videoCardEl) => {
      if (!videoCardEl || videoCardEl.offsetParent === null) return;
      const style = window.getComputedStyle(videoCardEl);
      if (style.position !== "sticky") return;
      const rect = videoCardEl.getBoundingClientRect();
      if (rect.height <= 0) return;
      height = Math.max(height, Math.round(rect.height));
    });
    return height;
  }

  /* Cible du défilement: la carte Étape 1 (créneaux), pas le titre du bloc. Sur
     téléphone l'ordre est titre → vidéo collante → formulaire, donc viser le
     titre remplissait l'écran de vidéo. Repli sur le titre tant que le moteur
     de réservation n'est pas rendu. */
  function getScrollAnchor(target) {
    if (slotStepPanelEl && slotStepPanelEl.offsetParent !== null && target.contains(slotStepPanelEl)) {
      return slotStepPanelEl;
    }
    return target.querySelector("[data-booking-scroll-anchor]") || target;
  }

  /* CTA du hero: défilement doux vers le bloc formulaire, sous le header collant. */
  function scrollToSection(target) {
    if (!target) return;
    const anchor = getScrollAnchor(target);
    const stickyVideoHeight = anchor === slotStepPanelEl ? getStickyVideoHeight() : 0;
    const offset = getMobileStickyTop() + (stickyVideoHeight ? stickyVideoHeight + 12 : 0);
    const top = Math.max(0, window.pageYOffset + anchor.getBoundingClientRect().top - offset);
    const reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    try {
      window.scrollTo({ top: top, behavior: reduceMotion ? "auto" : "smooth" });
    } catch (_error) {
      window.scrollTo(0, top);
    }
    if (typeof target.focus === "function") {
      try {
        target.focus({ preventScroll: true });
      } catch (_error) {}
    }
  }

  function initScrollLinks() {
    Array.from(document.querySelectorAll("[data-booking-scroll-to]")).forEach((linkEl) => {
      linkEl.addEventListener("click", (event) => {
        const selector = String(linkEl.getAttribute("data-booking-scroll-to") || "").trim();
        if (!selector) return;
        let target = null;
        try {
          target = document.querySelector(selector);
        } catch (_error) {
          target = null;
        }
        if (!target) return;
        event.preventDefault();
        scrollToSection(target);
        if (window.history && typeof window.history.replaceState === "function") {
          window.history.replaceState(null, "", selector);
        }
        trackBookingEvent("appointment_intent", { action: "scroll_to_booking", city: currentCity });
      });
    });
  }

  function getCitySwitchStickyTop(stickyTop) {
    const margin = 12;
    let nextTop = stickyTop;
    videoCardEls.forEach((videoCardEl) => {
      const videoRect = videoCardEl.getBoundingClientRect();
      if (videoRect.width <= 0 || videoRect.height <= 0) return;
      const videoIsRelevant = videoRect.bottom > stickyTop + margin && videoRect.top < window.innerHeight;
      if (!videoIsRelevant) return;
      nextTop = Math.max(nextTop, Math.round(videoRect.bottom + margin));
    });
    return nextTop;
  }

  function resetCitySwitchSticky() {
    if (!citySwitchEl || !citySwitchSlotEl) return;
    citySwitchEl.classList.remove("is-mobile-sticky");
    citySwitchEl.style.removeProperty("--appointments-city-sticky-top");
    citySwitchEl.style.removeProperty("--appointments-city-sticky-left");
    citySwitchEl.style.removeProperty("--appointments-city-sticky-width");
    citySwitchSlotEl.style.removeProperty("--appointments-city-sticky-height");
  }

  function fixCitySwitchSticky(stickyTop) {
    if (!citySwitchEl || !citySwitchSlotEl) return;
    const slotRect = citySwitchSlotEl.getBoundingClientRect();
    citySwitchSlotEl.style.setProperty("--appointments-city-sticky-height", `${Math.round(slotRect.height)}px`);
    citySwitchEl.style.setProperty("--appointments-city-sticky-top", `${stickyTop}px`);
    citySwitchEl.style.setProperty("--appointments-city-sticky-left", `${Math.round(slotRect.left)}px`);
    citySwitchEl.style.setProperty("--appointments-city-sticky-width", `${Math.round(slotRect.width)}px`);
    citySwitchEl.classList.add("is-mobile-sticky");
  }

  function updateCitySwitchSticky() {
    citySwitchStickyRaf = 0;
    if (!citySwitchEl || !citySwitchSlotEl || !slotStepPanelEl) return;
    const isMobile = window.matchMedia && window.matchMedia("(max-width: 720px)").matches;
    const stickyTop = syncMobileStickyTop();
    const stepIsVisible = !slotStepPanelEl.hidden && slotStepPanelEl.offsetParent !== null;
    if (!isMobile || currentStep !== "slot" || !stepIsVisible) {
      resetCitySwitchSticky();
      return;
    }

    const citySwitchStickyTop = getCitySwitchStickyTop(stickyTop);
    const slotTop = getDocumentTop(citySwitchSlotEl);
    const panelRect = slotStepPanelEl.getBoundingClientRect();
    const switchHeight = citySwitchEl.getBoundingClientRect().height || citySwitchSlotEl.getBoundingClientRect().height || 0;
    const shouldStart = window.scrollY + citySwitchStickyTop >= slotTop;
    const shouldStop = panelRect.bottom <= citySwitchStickyTop + switchHeight + 12;

    if (shouldStart && !shouldStop) {
      fixCitySwitchSticky(citySwitchStickyTop);
      return;
    }
    resetCitySwitchSticky();
  }

  function scheduleCitySwitchStickyUpdate() {
    if (citySwitchStickyRaf) return;
    citySwitchStickyRaf = window.requestAnimationFrame(updateCitySwitchSticky);
  }

  function setSelectedSlot(slot) {
    if (currentCity !== "casablanca") {
      selectedSlot = null;
      if (submitEl) submitEl.disabled = true;
      return;
    }
    selectedSlot = slotIsStillBookable(slot) ? slot : null;
    if (selectedSlot) setBookingSent(false);
    if (selectedEl) {
      selectedEl.textContent = selectedSlot
        ? (t("selectedPrefix", "Requested time: ") + formatSlotSummary(selectedSlot))
        : t("selectedEmpty", "No time selected.");
    }
    if (selectedNoteEl) {
      selectedNoteEl.hidden = !selectedSlot;
    }
    if (submitEl) submitEl.disabled = !selectedSlot;
    if (selectedSlot) {
      trackBookingEvent("appointment_intent", {
        action: "slot_selected",
        city: currentCity,
        slotDate: selectedSlot.date || ""
      });
      setStep("details", { scroll: true });
    } else {
      setStep("slot");
    }
  }

  async function fetchJson(url, init) {
    const response = await fetch(url, init);
    const parsed = await response.json();
    if (!response.ok || !parsed || parsed.ok !== true) {
      throw new Error(parsed && parsed.error ? parsed.error : "request_failed");
    }
    return parsed;
  }

  function formatDateLabel(dateText) {
    const parsed = new Date(String(dateText || "") + "T12:00:00");
    if (Number.isNaN(parsed.getTime())) return String(dateText || "");
    return parsed.toLocaleDateString(locale, {
      weekday: "long",
      day: "numeric",
      month: "long"
    });
  }

  function typeLabel(type) {
    return typeLabels[String(type || "fitting")] || "Appointment";
  }

  function formatSlotSummary(slot) {
    if (!slot) return "";
    return formatDateLabel(slot.date) + " · " + String(slot.label || "");
  }

  function setShowroomDetail(name, value) {
    if (!showroomDetailEls.length) return;
    showroomDetailEls.forEach((element) => {
      if ((element.getAttribute("data-showroom-detail") || "") === name) {
        element.textContent = value;
      }
    });
  }

  function syncShowroomDetails() {
    if (!showroomDetailEls.length || !config) return;
    const locationValue = config.storefrontLocation || t("metaToConfirm", "To be confirmed");
    const durationMinutes = Number(config.slotDurationMinutes || 0);
    const durationValue = Number.isFinite(durationMinutes) && durationMinutes > 0
      ? `${durationMinutes} ${t("durationSuffix", "min")}`
      : t("metaToConfirm", "To be confirmed");
    setShowroomDetail("location", locationValue);
    setShowroomDetail("duration", durationValue);
    setShowroomDetail("type", typeLabel(config.storefrontAppointmentType || "vip_consultation"));
  }

  function formatPreferenceDate(dateText, options) {
    const settings = options || {};
    const raw = String(dateText || "").trim();
    const parsed = new Date(raw + "T12:00:00");
    if (!raw || Number.isNaN(parsed.getTime())) return raw;
    return parsed.toLocaleDateString(locale, {
      weekday: settings.weekday ? "short" : undefined,
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    });
  }

  function buildGeneratedPreferenceDates() {
    const dates = [];
    const today = new Date();
    for (let offset = 1; offset <= 45; offset += 1) {
      const date = new Date(today.getFullYear(), today.getMonth(), today.getDate() + offset);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      dates.push(`${year}-${month}-${day}`);
    }
    return dates;
  }

  function setPreferenceDate(value) {
    const normalized = String(value || "").trim();
    if (!preferenceDateEl || !normalized) return;
    preferenceDateEl.value = formatPreferenceDate(normalized);
    preferenceDateEl.setAttribute("data-booking-preference-date-value", normalized);
    if (preferenceDateOptionsEl) {
      Array.from(preferenceDateOptionsEl.querySelectorAll("[data-preference-date-value]")).forEach((button) => {
        button.classList.toggle("is-selected", button.getAttribute("data-preference-date-value") === normalized);
      });
    }
  }

  function setPreferenceTime(value) {
    const normalized = String(value || "").trim();
    if (!preferenceTimeEl || !normalized) return;
    preferenceTimeEl.value = normalized;
    if (preferenceTimeOptionsEl) {
      Array.from(preferenceTimeOptionsEl.querySelectorAll("[data-preference-time-value]")).forEach((button) => {
        button.classList.toggle("is-selected", button.getAttribute("data-preference-time-value") === normalized);
      });
    }
  }

  function renderPreferenceOptions() {
    const availableDates = config && Array.isArray(config.availableDates) && config.availableDates.length
      ? config.availableDates.slice(0, 9)
      : buildGeneratedPreferenceDates().slice(0, 9);
    if (preferenceDateOptionsEl) {
      preferenceDateOptionsEl.innerHTML = availableDates.map((date) => {
        return "<button type=\"button\" class=\"appointments-booking-preference-option\" data-preference-date-value=\"" + date + "\">" + formatPreferenceDate(date, { weekday: true }) + "</button>";
      }).join("");
      preferenceDateOptionsEl.querySelectorAll("[data-preference-date-value]").forEach((button) => {
        button.addEventListener("click", () => setPreferenceDate(button.getAttribute("data-preference-date-value")));
      });
    }
    if (preferenceTimeOptionsEl) {
      preferenceTimeOptionsEl.innerHTML = preferenceTimeOptions.map((time) => {
        return "<button type=\"button\" class=\"appointments-booking-preference-option\" data-preference-time-value=\"" + time + "\">" + time + "</button>";
      }).join("");
      preferenceTimeOptionsEl.querySelectorAll("[data-preference-time-value]").forEach((button) => {
        button.addEventListener("click", () => setPreferenceTime(button.getAttribute("data-preference-time-value")));
      });
    }
    // Le rendu réécrit les puces: on réapplique la sélection courante, sinon
    // rouvrir la popup laissait le champ rempli mais aucune puce marquée.
    if (preferenceDateEl) {
      const currentDate = String(preferenceDateEl.getAttribute("data-booking-preference-date-value") || "").trim();
      const nextDate = currentDate || availableDates[0] || "";
      if (nextDate) setPreferenceDate(nextDate);
    }
    if (preferenceTimeEl) {
      const currentTime = String(preferenceTimeEl.value || "").trim();
      const nextTime = currentTime || preferenceTimeOptions[0] || "";
      if (nextTime) setPreferenceTime(nextTime);
    }
  }

  function openWhatsAppPreference() {
    const phone = String(root.getAttribute("data-booking-whatsapp") || "").replace(/[^\d]/g, "");
    if (!phone || !preferenceDateEl || !preferenceTimeEl) return;
    const date = String(preferenceDateEl.value || "").trim();
    const time = String(preferenceTimeEl.value || "").trim();
    const note = preferenceNotesEl ? String(preferenceNotesEl.value || "").trim() : "";
    if (!date || !time) return;
    const lines = [];
    const intro = String(t("preferenceMessageIntro", "") || "").trim();
    if (intro) {
      lines.push(intro);
    }
    lines.push(`${t("preferenceMessageDate", "I would like an appointment on")} ${date} ${t("preferenceMessageTime", "at")} ${time}.`);
    const locationLine = String(t("preferenceMessageLocation", "") || "").trim();
    if (locationLine) {
      lines.push(locationLine);
    }
    if (note) {
      lines.push(`${t("preferenceMessageNote", "Additional note:")} ${note}`);
    }
    window.location.href = `https://wa.me/${phone}?text=${encodeURIComponent(lines.join("\n"))}`;
  }

  async function loadConfig() {
    setLoading(true);
    showError("");
    setAppVisible(true);
    if (dateSelectEl) dateSelectEl.disabled = true;
    try {
      const payload = await fetchJson("/apps/appointments/config");
      config = payload.config || null;
      if (!config || !config.storefrontEnabled) {
        throw new Error(t("errorDisabled", "Online appointments are not available at the moment."));
      }
      if (dateSelectEl) {
        dateSelectEl.disabled = false;
        dateSelectEl.innerHTML = (config.availableDates || []).map((date) => {
          return "<option value=\"" + date + "\">" + formatDateLabel(date) + "</option>";
        }).join("");
      }
      if (metaEl) {
        const locationValue = config.storefrontLocation || t("metaToConfirm", "To be confirmed");
        metaEl.innerHTML = "<a class=\"appointments-booking-meta-item appointments-booking-meta-item--location\"" +
          (locationUrl ? (" href=\"" + locationUrl + "\" target=\"_blank\" rel=\"noopener noreferrer\"") : "") +
          ">" +
            "<span class=\"appointments-booking-meta-label\">" + t("metaLocation", "Location") + "</span>" +
            "<span class=\"appointments-booking-meta-value\">" + locationValue + "</span>" +
          "</a>";
      }
      syncShowroomDetails();
      renderPreferenceOptions();
      const availableDates = Array.isArray(config.availableDates) ? config.availableDates.slice() : [];
      if (dateSelectEl && availableDates.length > 0) {
        const primaryDate = dateSelectEl.value || availableDates[0] || "";
        if (primaryDate) {
          dateSelectEl.value = primaryDate;
          const primaryResult = await loadAvailability(primaryDate, { suppressEmptyState: availableDates.length > 1 });
          if ((!primaryResult || !primaryResult.hasSlots) && availableDates.length > 1) {
            const fallbackDate = availableDates.find((date) => date && date !== primaryDate) || "";
            if (fallbackDate) {
              dateSelectEl.value = fallbackDate;
              await loadAvailability(fallbackDate);
            }
          }
        }
      } else {
        renderSlotsState(t("errorEmptySlots", "No availability for this date."));
      }
    } catch (error) {
      showError(localizeErrorMessage(error instanceof Error ? error.message : "", t("errorLoading", "Unable to load appointments.")));
      setAppVisible(false);
      if (dateSelectEl) dateSelectEl.disabled = true;
    } finally {
      setLoading(false);
    }
  }

  async function loadAvailability(date, options) {
    const settings = options || {};
    if (!date) return { hasSlots: false, slots: [] };
    showInlineError("");
    // keepStep: rafraîchir les créneaux sans renvoyer la cliente à l'étape 1
    // (utilisé après un envoi réussi, pour garder la confirmation à l'écran).
    if (!settings.keepStep) setSelectedSlot(null);
    renderSlotsState(t("loading", "Loading availability..."));
    try {
      const payload = await fetchJson("/apps/appointments/availability?date=" + encodeURIComponent(date));
      const slots = (Array.isArray(payload.slots) ? payload.slots : []).filter(slotIsStillBookable);
      if (!slotsEl) return { hasSlots: slots.length > 0, slots };
      if (!slots.length) {
        if (!settings.suppressEmptyState) {
          renderSlotsState(t("errorEmptySlots", "No availability for this date."));
        }
        return { hasSlots: false, slots: [] };
      }
      slotsEl.innerHTML = slots.map((slot, index) => {
        return "<button type=\"button\" class=\"appointments-booking-slot\" data-slot-index=\"" + index + "\" data-slot-badge=\"" + t("slotBadge", "Private availability") + "\">" + slot.label + "</button>";
      }).join("");
      slotsEl.querySelectorAll("[data-slot-index]").forEach((button) => {
        button.addEventListener("click", () => {
          const index = Number(button.getAttribute("data-slot-index") || "-1");
          const slot = slots[index] || null;
          Array.from(slotsEl.querySelectorAll(".appointments-booking-slot")).forEach((node) => {
            node.classList.toggle("is-selected", node === button);
          });
          setSelectedSlot(slot);
        });
      });
      return { hasSlots: true, slots };
    } catch (error) {
      const message = localizeErrorMessage(error instanceof Error ? error.message : "", t("errorSlots", "Unable to load times."));
      showInlineError(message);
      renderSlotsState(message, "is-error");
      return { hasSlots: false, slots: [] };
    }
  }

  if (dateSelectEl) {
    dateSelectEl.addEventListener("change", () => loadAvailability(dateSelectEl.value));
  }

  cityTabEls.forEach((tab) => {
    tab.addEventListener("click", () => {
      const city = tab.getAttribute("data-booking-city-tab") || "casablanca";
      setSelectedSlot(null);
      setCity(city);
      if (city === "casablanca" && dateSelectEl && dateSelectEl.value) {
        loadAvailability(dateSelectEl.value);
      }
    });
  });

  if (preferenceToggleEl) {
    preferenceToggleEl.addEventListener("click", () => {
      if (currentCity !== "casablanca") return;
      trackBookingEvent("appointment_intent", { action: "preference_opened", city: currentCity });
      renderPreferenceOptions();
      setPreferenceVisible(true);
    });
  }

  preferenceCloseEls.forEach((button) => {
    button.addEventListener("click", () => setPreferenceVisible(false));
  });

  if (preferenceModalEl) {
    preferenceModalEl.addEventListener("click", (event) => {
      if (event.target === preferenceModalEl) {
        setPreferenceVisible(false);
      }
    });
  }

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && preferenceVisible) {
      setPreferenceVisible(false);
    }
  });

  if (preferenceFormEl) {
    preferenceFormEl.addEventListener("submit", (event) => {
      event.preventDefault();
      trackBookingEvent("appointment_intent", { action: "preference_whatsapp", city: currentCity });
      openWhatsAppPreference();
    });
  }

  stepTabEls.forEach((tab) => {
    tab.addEventListener("click", () => {
      const step = tab.getAttribute("data-booking-step-tab") || "slot";
      if (step === "details" && !selectedSlot) return;
      setStep(step);
    });
  });

  if (stepBackEl) {
    stepBackEl.addEventListener("click", () => {
      setStep("slot");
    });
  }

  if (formEl) {
    formEl.addEventListener("submit", async (event) => {
      event.preventDefault();
      showInlineError("");
      setBookingSent(false);
      if (!selectedSlot) {
        showInlineError(t("errorChoose", "Please choose a time."));
        return;
      }
      if (!slotIsStillBookable(selectedSlot)) {
        setSelectedSlot(null);
        showInlineError(t("errorExpired", "This time is no longer available. Please choose another one."));
        if (dateSelectEl && dateSelectEl.value) {
          await loadAvailability(dateSelectEl.value);
        }
        return;
      }
      const formData = new FormData(formEl);
      const whatsappLeadRef = buildAppointmentLeadRef();
      if (submitEl) submitEl.disabled = true;
      trackBookingEvent("appointment_submit", {
        action: "booking_submit",
        city: currentCity,
        slotDate: selectedSlot.date || "",
        whatsappLeadRef: whatsappLeadRef
      });
      try {
        const payload = await fetchJson("/apps/appointments/book", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            customerName: String(formData.get("customerName") || ""),
            customerPhone: String(formData.get("customerPhone") || ""),
            customerEmail: String(formData.get("customerEmail") || ""),
            notes: String(formData.get("notes") || ""),
            whatsappLeadRef: whatsappLeadRef,
            date: selectedSlot.date,
            appointmentAt: selectedSlot.appointmentAt,
            fingerprint: window.navigator.userAgent
          })
        });
        const bookedSlot = selectedSlot;
        trackBookingEvent("appointment_success", {
          action: "booking_success",
          city: currentCity,
          slotDate: bookedSlot.date || "",
          whatsappLeadRef: String(payload && payload.appointment && payload.appointment.whatsappLeadRef || whatsappLeadRef)
        });
        selectedSlot = null;
        formEl.reset();
        setBookingSent(true, bookedSlot);
        if (dateSelectEl && dateSelectEl.value) {
          await loadAvailability(dateSelectEl.value, { keepStep: true });
        }
      } catch (error) {
        const errorCode = error instanceof Error ? error.message : "";
        trackBookingEvent("appointment_error", {
          action: "booking_error",
          city: currentCity,
          errorCode: errorCode || "request_failed"
        });
        showInlineError(localizeErrorMessage(errorCode, t("errorBooking", "Unable to submit your request.")));
      } finally {
        if (submitEl) submitEl.disabled = !selectedSlot;
      }
    });
  }

  window.addEventListener("scroll", scheduleCitySwitchStickyUpdate, { passive: true });
  window.addEventListener("resize", scheduleCitySwitchStickyUpdate, { passive: true });
  window.addEventListener("orientationchange", scheduleCitySwitchStickyUpdate, { passive: true });

  setStep("slot");
  setCity("casablanca");
  initScrollLinks();
  initVideo();
  loadConfig();
})();
